import React, { Suspense } from 'react';
import Page, { PageHeader, PageTitle } from 'components/Page';
import Button from 'packages/ui/Button';
import { Link } from 'react-router-dom';
import Loading from 'components/Loading';
import { PromotesUIProvider } from './PromotesContextProvider';

const PromotesList = React.lazy(() => import('./Promotes'));

function EvandPromotes(props) {
  return (
    <Page>
      <PageHeader>
        <PageTitle>پیام‌های ایوند</PageTitle>
        <Button as={Link} type="anchor" to="/evand-promot/new">
          ایجاد پیام جدید
        </Button>
      </PageHeader>

      <Suspense fallback={<Loading />}>
        <PromotesUIProvider>
          <PromotesList {...props} />
        </PromotesUIProvider>
      </Suspense>
    </Page>
  );
}

export default EvandPromotes;
